import { event } from 'jquery';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-lazyloadimage',
  templateUrl: './lazyloadimage.component.html',
  styleUrls: ['./lazyloadimage.component.css']
})
export class LazyloadimageComponent implements OnInit {
  @Input() defaultImage: any;
  @Input() images: any;
  @Input() category: any;
  @Input() size: any;
  sources: any = ['CM', 'OL', 'GB', 'MR', 'PQ'];
  image: any;
  isLoading: any = false;
  imagesAll: any = [];
  index: any = 0;

  constructor() { }

  ngOnInit(): void {
    this.onLoadImages();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.imagesAll = []
    this.onLoadImages();
  }

  checkImageWidth(imageUrl: string): Promise<boolean> {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageUrl;

      image.onload = () => {
        const width = image.width;
        resolve(width >= 5);
      };

      image.onerror = () => {
        resolve(false);
      };
    });
  }

  async onLoadImages() {
    const sizeOrder = ['xl', 'l', 'm', 's', 'xs', 'xxs'];  // Size preference order
    // Loop over sizes and sources in priority order
    for (const size of sizeOrder) {
      for (const src of this.sources) {
        for (const img of this.images) {
          if (img.size === size && img.source === src) {
            const meetsWidthCondition = await this.checkImageWidth(img.url);
            if (meetsWidthCondition) {
              this.imagesAll.push(img.url);
            }
          }
        }
      }
    }
  
    if (this.imagesAll.length > 0) {
      this.image = this.imagesAll[0];  // Get first valid image
      this.isLoading = false;
    } else {
      this.isLoading = true;
    }
  }

}
